export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			required: true,
			is_title: true,
		},
		{
			text: 'Slug',
			key: 'slug',
			type: 'text',
			required: true,
		},
	],
	singular_model_name_spanish: 'Tamaño de inputs',
	plural_model_name_spanish: 'Tamaños de inputs',
	create_model_name_spanish: 'Nuevo tamaño de inputs',
	text_delete: 'el',
}
